<div [className]="cargando ? 'fondooscuro':'oculta'">
    <div [className]="cargando ? 'fondooscuro':'oculta'"></div>
    <div [className]="cargando ? 'contenedormodal':'oculta'">
        <k-loader [color]="color" [size]="size"></k-loader>
        <p style="margin-top: 15px;">Estamos validando tu pago {{punto}}</p>
    </div>
</div>